import { Routes } from '@angular/router';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Role } from './shared/components/custom-sidenav/role';
import { filter, map } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component'),
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component')
      },
      {
        path: 'issuer-monitoring',
        loadChildren: () => import('./features/issuer-monitoring/issuer-monitoring.routes'),
        canMatch: [canMatchWithRoles([Role.Admin, Role.WorkflowMenuView])]
      },
      {
        path: 'loans',
        loadChildren: () => import('./features/loans/loan.routes')
      },
      {
        path: 'search-results',
        // Has its own heading ("Results for …"), so no page header above it.
        data: { pageHeader: false },
        loadComponent: () => import('./features/global-search/search-results.component')
      },
      {
        path: 'documents',
        loadChildren: () => import('./features/documents/documents.routes')
      },
      {
        path: 'playground',
        loadComponent: () => import('./features/playground/playground.component')
      },
      {
        path: 'powerbi',
        loadChildren: () => import('./features/powerbi/powerbi.routes'),
        canMatch: [canMatchWithRoles([Role.Admin, Role.ReportMenuView])]
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes'),
        canMatch: [canMatchWithRoles([Role.Admin, Role.GlobalAdmin])]
      },
      {
        path: 'products',
        loadChildren: () => import('./features/products/products.routes'),
        canMatch: [canMatchWithRoles([Role.Admin, Role.ProductMenuView])]
      },
      {
        path: 'pools',
        loadChildren: () => import('./features/pools/pools.routes'),
        canMatch: [canMatchWithRoles([Role.Admin, Role.PoolMenuView])]
      },
      {
        path: 'portfolio-monitoring',
        loadChildren: () => import('./features/loans/loan-product-based.routes')
      },
      {
        path: 'servicing-transfer',
        loadChildren: () => import('./features/loans/loan-product-based.routes')
      },
      {
        path: 'invoice-reconciliation',
        loadChildren: () => import('./features/loans/loan-product-based.routes')
      },
       {
        path: 'bk-services',
        loadChildren: () => import('./features/bk-services/bk-services.routes')
      },
    ]
  }
];
export function canMatchWithRoles(allowedRoles: string[]): CanMatchFn {
  return () => {
    const router = inject(Router);
    const msalBroadcast = inject(MsalBroadcastService);
    const msalService = inject(MsalService);

    return msalBroadcast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      map(() => {
        const account = msalService.instance.getActiveAccount() || msalService.instance.getAllAccounts()[0];
        const userRoles: string[] = account?.idTokenClaims?.roles || [];

        const hasRole = allowedRoles.some((role) => userRoles.includes(role));

        if (!hasRole) {
          router.navigate(['/dashboard']);
          return false;
        }

        return true;
      })
    );
  };
}
